export const localePersistenceConfig = {
  storageKey: 'tcode-ai_language',
} as const;
